import React from 'react';
import { Heading, SimpleGrid, Box, Text } from '@chakra-ui/react';
import {
  CIL,
  SECTION_TITLE_CONTAINER_BG,
  SECTION_TITLE_TEXT_COLOR,
} from './constants';
import TiltedCard from '../TiltedCard';

import ce3 from '../../images/ce-2025-3.jpg';
import ce2026Settimane from '../../images/ce-2026/Backstage.00_00_39_14.Immagine003.jpg';
import ce2026Attivita from '../../images/ce-2026/Primitivi.00_04_42_05.Immagine002.jpg';
import ce2026MomentoFinale from '../../images/ce-2026/DSC09012.jpg';

const experienceItems = [
  {
    title: 'Gruppo e ambiente familiare',
    description:
      'Numero di partecipanti limitato a 60 posti per garantire un gruppo e un ambiente familiare.',
    image: ce3,
  },
  {
    title: 'Attività separate',
    description:
      'Il gruppo delle medie chiamato "Il club dei grandi" svolge attività misurate alla fascia d\'età diversa.',
    image: ce2026Attivita,
  },
  {
    title: 'Settimane tematizzate',
    description: 'Attività e storie inedite ogni settimana.',
    image: ce2026Settimane,
  },
  {
    title: 'Momento finale',
    description:
      'Il venerdì aspettiamo i genitori per una breve restituzione partecipata e un piccolo rinfresco per salutarci!',
    image: ce2026MomentoFinale,
  },
];

const imageHeight = 240;

const ExperienceSection = () => (
  <Box
    as="section"
    id="section-experience"
    py={{ base: 10, md: 14 }}
    scrollMarginTop={{ base: '80px', md: '140px' }}
  >
    <Box w="100%" maxW="100%" px={{ base: 4, md: 6, lg: 8 }}>
      <Heading as="h2" size="lg" mb={8} textAlign="center">
        <Box
          w="100%"
          px={4}
          py={3}
          borderRadius="lg"
          sx={{ background: SECTION_TITLE_CONTAINER_BG }}
          boxShadow="sm"
        >
          <Text as="span" fontWeight="bold" color={SECTION_TITLE_TEXT_COLOR}>
            L&apos;esperienza
          </Text>
        </Box>
      </Heading>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} w="100%" maxW="100%">
        {experienceItems.map(({ title, description, image }) => (
          <Box
            key={title}
            borderRadius="xl"
            overflow="hidden"
            boxShadow="0 4px 20px rgba(0, 0, 0, 0.1), 0 8px 32px rgba(0, 0, 0, 0.06)"
            bg="white"
            _hover={{
              boxShadow:
                '0 8px 28px rgba(0, 0, 0, 0.14), 0 12px 40px rgba(0, 0, 0, 0.08)',
            }}
            transition="box-shadow 0.2s"
          >
            <Box overflow="hidden" h={`${imageHeight}px`}>
              <TiltedCard
                imageSrc={image}
                altText={title}
                containerHeight={`${imageHeight}px`}
                containerWidth="100%"
                imageHeight={imageHeight}
                imageWidth="100%"
                scaleOnHover={1.02}
                rotateAmplitude={10}
              />
            </Box>
            <Box p={5}>
              <Text fontWeight="bold" fontSize="lg" color={CIL.plum} mb={2}>
                {title}
              </Text>
              <Text fontSize="sm" color="gray.600">
                {description}
              </Text>
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  </Box>
);

export default ExperienceSection;
